<template>
  <div>
    <commonTable
      ref="commonTable"
      url="/admin/coupon_batches/orderIndex"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
      :isList="true"
    >
      <template slot="summary" slot-scope="scope">
        <!-- 订单统计 -->
        <ul class="order-statistics" v-if="scope.summaryData">
          <li>
            <span>总充值笔数：</span>
            <em>{{ scope.summaryData.count }}</em>
          </li>
          <li>
            <span>总充值金额：</span>
            <em>{{ scope.summaryData.amount }}</em>
          </li>
          <li>
            <span>总到账金额：</span>
            <em>{{ scope.summaryData.complete_amount }}</em>
          </li>
          <li>
            <span>支付成功率：</span>
            <em>{{ scope.summaryData.pay_success_rate }}</em>
          </li>
          <li>
            <span>平均到账金额：</span>
            <em>{{ scope.summaryData.average_amount }}</em>
          </li>
        </ul>
      </template>
    </commonTable>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js"
import commonTable from '@/component/commonTable.vue'
export default {
  name: 'voucherOrder',
  components: {
    commonTable
  },
  data () {
    return {
      gamesList: [],
      orderStatus: [
        {
          value: 0,
          label: '已取消'
        },
        {
          value: 10,
          label: '待付款'
        },
        {
          value: 100,
          label: '已完成'
        }
      ]
    }
  },
  computed: {
    text () {
      return this.isEdit !== '' ? '编辑' : '新增'
    },
    column () {
      return [
        {
          label: "订单编号",
          prop: "order_no",
          fixed: true
        },
        {
          label: "用户账号",
          prop: "user.username",
          fixed: true
        },
        {
          label: "游戏",
          prop: "game.name"
        },
        {
          label: "商品",
          prop: "coupon_batch.name"
        },
        {
          label: "订单金额",
          prop: "amount",
          formatter: (row, column, cellValue) => {
            return '￥' + cellValue
          }
        },
        {
          label: "订单状态",
          prop: "status",
          formatter: (row, column, cellValue) => {
            const target = this.orderStatus.find(item => item.value === cellValue)
            return target && target.label ? target.label : '-'
          }
        },
        {
          label: "时间",
          prop: "created_at",
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: "订单编号",
          prop: "order_no",
          type: "input",
        },
        {
          label: "账号",
          prop: "username",
          type: "input",
        },
        {
          label: "游戏",
          prop: "game_id",
          type: "select",
          option: this.gamesList
        },
        {
          label: "状态",
          prop: "status",
          type: "select",
          option: this.orderStatus
        },
        {
          label: "提交时间",
          prop: "created_at_start+created_at_end",
          type: "date",
          timerange: []
        },
      ]
    }
  },
  mounted () {
    this.getGameSelectList()
  },
  methods: {
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.order-statistics {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 0;
  color: rgba(0, 0, 0, 0.7);
  margin-bottom: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding-left: 10px;
  list-style: none;
  li {
    margin-right: 30px;
  }
}

</style>
